import { keepPreviousData } from "@tanstack/react-query";
import { useGetV4AdvReportByAd } from "./v4AdvReportByAd";

type Params = {
  adId: string | number;
};

type Options = {
  enabled?: boolean;
};

export const useAdPlanDetails = ({ adId }: Params, { enabled = true }: Options = {}) => {
  const adByAdOptionsGetter = useGetV4AdvReportByAd();
  const numericAdId = Number(adId);

  return {
    ...adByAdOptionsGetter({
      pagination: {
        pageIndex: 0,
        pageSize: 1,
      },
      sorting: [],
      filters: [
        {
          id: "ad_id",
          value: { op: "=", value: numericAdId },
        },
      ],
    }),
    enabled,
    placeholderData: keepPreviousData,
  };
};
